export default __webpack_public_path__ + "static/media/arrowUpGreen.c64652e6.svg";